import React from "react";
import { AnalyticsStatsCardPlaceholder } from "components/analytics/placeholder";
import { Separator } from "ui/components/separator";

const AnalyticsStatsLoader = () => {
  return (
    <div className="flex-1 lg:flex gap-4 lg:gap-6 items-center lg:flex-row grid sm:grid-cols-2 grid-cols-1  ">
      <AnalyticsStatsCardPlaceholder />{" "}
      <Separator orientation="vertical" className="min-h-16 hidden lg:block" />
      <AnalyticsStatsCardPlaceholder />{" "}
      <Separator orientation="vertical" className="min-h-16 hidden lg:block" />
      <AnalyticsStatsCardPlaceholder />{" "}
      <Separator orientation="vertical" className="min-h-16 hidden lg:block" />
      <AnalyticsStatsCardPlaceholder />{" "}
      <Separator orientation="vertical" className="min-h-16 hidden lg:block" />
      <AnalyticsStatsCardPlaceholder />{" "}
    </div>
  );
};

export default AnalyticsStatsLoader;
